import { callApiWithToken } from './base';
import config from '../../config';

export const fetchSites = async (token: string) =>
  callApiWithToken(`${config.urls.sites}`, token, 'GET');
